import { Center } from "@mantine/core";
import { motion, useReducedMotion } from "motion/react";

export function BootLoader() {
  const reduced = useReducedMotion();

  return (
    <Center h="100vh">
      <motion.img
        src="/noxus-emblem.svg"
        alt="Noxus"
        width={72}
        height={72}
        initial={{ opacity: reduced ? 1 : 0.4 }}
        animate={reduced ? { opacity: 1 } : { opacity: [0.4, 1, 0.4] }}
        transition={
          reduced
            ? undefined
            : { duration: 1.6, repeat: Infinity, ease: "easeInOut" }
        }
      />
    </Center>
  );
}
